import { render, staticRenderFns } from "./LookupLabelCombo.vue?vue&type=template&id=064be9cf&scoped=true"
import script from "./LookupLabelCombo.vue?vue&type=script&lang=js"
export * from "./LookupLabelCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064be9cf",
  null
  
)

export default component.exports